import React, { Fragment, useContext, useEffect, useState } from "react";
import { _O } from "../../modules/utils";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { Container, DateLayer } from "../Layout";
import { SubMenu } from "./ProofApply";

export default () => {
    // 다운로드 이벤트 추가
    const download = () => {
        alert("다운로드 이벤트 추가");
        _O.Open("/proof/claim");
    }

    return (
        <Fragment>
            <ScrollToTop />
            <Container Title="다운로드" proof="DOWNLOAD" onClick={()=>download()}>
                <div className="contents sub grad">
                    <SubMenu code="APPLY" />

                    <div className="sub-contents">
                        <div className="steps-bar-area">
                            <ul>
                                <li><a>STEP 1</a></li>
                                <li><a>STEP 2</a></li>
                                <li className="on"><a>STEP 3</a></li>
                                <li><a>STEP 4</a></li>
                            </ul>
                        </div>

                        <div className="sub-title">5. 신청한 서류를 확인할 수 있습니다. </div>
                        <div className="device-state-info res">
                            신청한 서류는 앱과 사진첩에서 확인하실 수 있습니다.
                        </div>

                        <div className="check-bar-area">
                            <ul>
                                <li>
                                    <label>
                                        <input type="checkbox" />
                                        <div>
                                            진단서	 <i></i>
                                        </div>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" />
                                        <div>
                                            진료비 계산영수증	 <i></i>
                                        </div>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" />
                                        <div>
                                            통원확인서	 <i></i>
                                        </div>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>	
                </div>
            </Container>
        </Fragment>
    );
}